// extracted by mini-css-extract-plugin
export default {"card":"WorkCard_card__mMLWB","cardImg":"WorkCard_cardImg__4cNSa","cardInfo":"WorkCard_cardInfo__k0FUM"};